import React from 'react';
import { toFormattedDate } from '@app/utilities';
import { useCurrentBillingPeriod } from '@app/sdk';
import { useAccountIdContext } from './AccountIdContext';

export default function CurrentBillingPeriod() {
  const { accountId } = useAccountIdContext();
  const { data: currentBillingPeriod, isLoading } = useCurrentBillingPeriod(accountId);
  return (
    <>
      <div className="row">
        <h3>Current Billing Period: {currentBillingPeriod?.billingPeriodId}</h3>
      </div>
      <div className="row">
        <h4 className="ui grey sub header">
          {toFormattedDate(currentBillingPeriod?.startDate)} - {toFormattedDate(currentBillingPeriod?.endDate)}
        </h4>
      </div>
      <div className="row">
        {currentBillingPeriod && (
          <div className="ui horizontal list">
            <div className="ui grey label">Next Statement Date: {toFormattedDate(currentBillingPeriod?.endDate)}</div>
          </div>
        )}
        {isLoading && <div className="ui active centered inline loader" />}
      </div>
    </>
  );
}
